/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type ServiceCancellationHubReturnQueryVariables = Types.Exact<{
  serviceAreaID: Types.Scalars['ID']['input']
}>

export type ServiceCancellationHubReturnQuery = {
  __typename?: 'Query'
  areas: Array<{
    __typename?: 'Area'
    id: string
    name: string | null
    details:
      | { __typename?: 'CooperationDetails' }
      | {
          __typename?: 'HubDetails'
          displayName: string
          hubStop: { __typename?: 'NavigationStop'; active: boolean } | null
        }
      | { __typename?: 'InFieldBreakDetails' }
      | { __typename?: 'ShortBreakDetails' }
      | null
  }>
}

export const ServiceCancellationHubReturnDocument = gql`
    query serviceCancellationHubReturn($serviceAreaID: ID!) {
  areas(serviceAreaID: $serviceAreaID) {
    id
    name
    details {
      ... on HubDetails {
        displayName
        hubStop {
          active
        }
      }
    }
  }
}
    `

/**
 * __useServiceCancellationHubReturnQuery__
 *
 * To run a query within a React component, call `useServiceCancellationHubReturnQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCancellationHubReturnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCancellationHubReturnQuery({
 *   variables: {
 *      serviceAreaID: // value for 'serviceAreaID'
 *   },
 * });
 */
export function useServiceCancellationHubReturnQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  > &
    (
      | {
          variables: ServiceCancellationHubReturnQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >(ServiceCancellationHubReturnDocument, options)
}
export function useServiceCancellationHubReturnLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >(ServiceCancellationHubReturnDocument, options)
}
export function useServiceCancellationHubReturnSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceCancellationHubReturnQuery,
        ServiceCancellationHubReturnQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ServiceCancellationHubReturnQuery,
    ServiceCancellationHubReturnQueryVariables
  >(ServiceCancellationHubReturnDocument, options)
}
export type ServiceCancellationHubReturnQueryHookResult = ReturnType<
  typeof useServiceCancellationHubReturnQuery
>
export type ServiceCancellationHubReturnLazyQueryHookResult = ReturnType<
  typeof useServiceCancellationHubReturnLazyQuery
>
export type ServiceCancellationHubReturnSuspenseQueryHookResult = ReturnType<
  typeof useServiceCancellationHubReturnSuspenseQuery
>
export type ServiceCancellationHubReturnQueryResult = Apollo.QueryResult<
  ServiceCancellationHubReturnQuery,
  ServiceCancellationHubReturnQueryVariables
>
